<template>
  <div style="padding: 0 16px 12px;">
    <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
      <div>
        <el-button type="warning" @click="sentPetImg">发送照片</el-button>
        <span style="margin-left: 16px">剩余发送次数：<span style="color: red">{{sendImgNum}}</span>次</span>
      </div>

      <el-button type="primary" @click="addImgObj">添加图片</el-button>
    </div>
    <table>
      <tr>
        <th>部位</th>
        <th>洗澡前</th>
        <th>洗澡后</th>
      </tr>
      <tr v-for="(item,index) in petImgList" :key="index">
        <td>{{ item.type == 1 ?'耳朵':item.type == 2?'脚底毛':item.type == 3?'背部':item.type == 4?'全身':'其他' }}</td>
        <td class="img-width">
          <div style="display: flex; align-items: center">
            <div v-if="item.value_a.smallImg" class="item-box">
              <el-image class="item-img" fit="cover" :src="item.value_a.smallImg" @click="upload(item.value_a.type, item.value_a.subType, item.value_a)"></el-image>
<!--              <div class="scale-icon" @click.prevent="showImg(item.value_a.img)"><i class="fa fa-arrows-alt" aria-hidden="true"></i></div>-->
            </div>
            <div class="add" v-else @click="upload(item.value_a.type, item.value_a.subType, item.value_a)"><span>+</span></div>
            <div v-if="item.value_a.operateAdminName">
              <p>拍摄者：{{ item.value_a.operateAdminName }}</p>
              <p>发送时间：{{ item.value_a.sendTime?item.value_a.sendTime:'未发送' }}</p>
              <div>
                <el-button style="padding: 0; height: 0;" type="text" size="small" @click="delImg(item.value_a.id)">删除图片</el-button>
                <el-button style="padding: 0; height: 0;" type="text" size="small" @click="showImg(item.value_a.img)">查看大图</el-button>
              </div>
            </div>

          </div>
        </td>
        <td class="img-width">
          <div style="display: flex; align-items: center">
            <div v-if="item.value_b.smallImg" class="item-box">
              <el-image class="item-img" fit="cover" :src="item.value_b.smallImg" @click="upload(item.value_b.type, item.value_b.subType, item.value_b)"></el-image>
<!--              <div class="scale-icon" @click.prevent="showImg(item.value_b.img)"><i class="fa fa-arrows-alt" aria-hidden="true"></i></div>-->
            </div>
            <div class="add" v-else @click="upload(item.value_b.type, item.value_b.subType, item.value_b)"><span>+</span></div>
            <div v-if="item.value_b.operateAdminName">
              <p> 拍摄者：{{ item.value_b.operateAdminName }}</p>
              <p>发送时间：{{ item.value_b.sendTime?item.value_b.sendTime:'未发送' }}</p>
              <el-button style="padding: 0; height: 0;" type="text" size="small" @click="delImg(item.value_b.id)">删除图片</el-button>
              <el-button style="padding: 0; height: 0;" type="text" size="small" @click="showImg(item.value_b.img)">查看大图</el-button>
            </div>

          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api";
import {listPreBookPetImg, delPreBookPetImg, sendPreBookPetImg} from "@/api/url";
import UserInfo from "@/components/User/userInfo";
import Dialog from "@/assets/js/dialog";
import UploadPetImgDialog from "@/views/preBook/components/UploadPetImgDialog";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "userStatList",
  components: {UserInfo},
  props: {
    value: Object
  },
  data() {
     return {
       preBookId: this.value.preBookId,
       preShopId: this.value.preShopId,
       petId: this.value.petId,

       petImgList: [],
       sendImgNum: 0

     }
  },
  methods: {

    getPage() {
      let param = {}
      param['preBookId'] = this.preBookId
      param['petId'] = this.petId
      getFormData(listPreBookPetImg, param).then(data => {
        let {code, msg} = data;
        if (code == 200) {
          let imgList = data.data.preBookPetImgList
          this.sendImgNum = data.data.sendImgNum
          this.petImgList = []
          for(let i=0; i<4; i++) {
            this.petImgList.push({
              type: i+1,
              value_a: {
                type: i+1,
                smallImg: '',
                img: '',
                operateAdminId: '',
                operateAdminName: '',
                sendTime: '',
                subType: 1,
                id:0,
              },
              value_b: {
                type: i+1,
                smallImg: '',
                img: '',
                operateAdminId: '',
                operateAdminName: '',
                sendTime: '',
                subType: 2,
                id:0,
              }
            })
            for(let j=0; j<imgList.length; j++) {
              if(imgList[j].type == this.petImgList[i].type) {
                if(imgList[j].subType == 1) {
                  this.petImgList[i].value_a = imgList[j]
                }else {
                  this.petImgList[i].value_b = imgList[j]
                }
              }
            }
          }

          let subArr = imgList.filter(item => item.type >= 10)
          subArr.map(item => {
            let obj = {
              type: item.type,
              value_a: {
                type: item.type,
                smallImg: '',
                img: '',
                operateAdminId: '',
                operateAdminName: '',
                sendTime: '',
                subType: 1,
                id:0,
              },
              value_b: {
                type: item.type,
                smallImg: '',
                img: '',
                operateAdminId: '',
                operateAdminName: '',
                sendTime: '',
                subType: 2,
                id:0,
              }
            }

            if(this.petImgList.every(p => p.type != item.type)) {
              this.petImgList.push(obj)
            }

            for(let k=0; k<this.petImgList.length; k++) {
              if(this.petImgList[k].type == item.type) {
                if(item.subType == 1) {
                  this.petImgList[k].value_a = item
                }
                if(item.subType == 2) {
                  this.petImgList[k].value_b = item
                }
              }
            }

          })

          console.log(this.petImgList)

          // let subList_1 = imgList.filter(item => item.subType == 1 && item.type >= 10)
          // let subList_2 = imgList.filter(item => item.subType == 2 && item.type >= 10)
          // this.addOtherObj(subList_1, subList_2)

        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    addImgObj() {
      let type = this.petImgList.length > 4?this.petImgList[this.petImgList.length-1].type:9
      let obj = {
        type: type + 1,
        value_a: {
          type: type + 1,
          smallImg: '',
          img: '',
          operateAdminId: '',
          operateAdminName: '',
          sendTime: '',
          subType: 1,
          id:0,
        },
        value_b: {
          type: type + 1,
          smallImg: '',
          img: '',
          operateAdminId: '',
          operateAdminName: '',
          sendTime: '',
          subType: 2,
          id:0,
        }
      }
      this.petImgList.push(obj)
      console.log(this.petImgList)
    },

    upload(type, subType, item) {
      let _title = type == 1?'耳朵 ':type == 2?'脚底毛':type == 3?'背部':type == 4?'全身':'其他'
      let imgForm = Object.assign({}, item);
      Dialog.open({
        title:  _title + '的图片',
        component: UploadPetImgDialog,
        data: {
          preShopId: this.preShopId,
          preBookId: this.preBookId,
          petId: this.petId,
          imgForm: imgForm,
          width: '400px',
          type: type,
          subType: subType,
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList,
      })
    },

    delImg(id) {
      this.$confirm('确认删除图片？').then(() => {
        postFormData(delPreBookPetImg, {id: id}).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    },

    sentPetImg() {
      this.$confirm('确定发送宠物洗澡照片给客户查看吗？').then(() => {
        postFormData(sendPreBookPetImg, {preBookId: this.preBookId, petId: this.petId}).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    }

  },
  created() {
    this.getPage()
  }
}
</script>

<style scoped>
table {
  border-collapse:collapse;
  width: 100%;
}

td,th {
  border: 1px solid #ebeef5;
  padding: 8px 8px;
  text-align: left;
}

th {
  background-color: #f5f7fa;
  color: #909399;
}

td {
  height: 80px;
}

/*.part-name {*/
/*  width: 80px;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.img-width {
  width: 280px;
}

.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  /*border: 1px dashed #ececec;*/
  font-size: 30px;
  cursor: pointer;
  background-color: #f6f6f6;
  /*margin: 0 auto*/
}

.item-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 16px;
}

.scale-icon {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 24px;
  height: 24px;
  /*border-radius: 14px 0 0 0;*/
  background-color: rgba(0,0,0,0.4);
  color: #ffffff;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 12px;
}


</style>
